import React, {
  createContext,
  useContext,
  useReducer,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { filterReducer } from 'reducers/filterReducer';

export const FilterContext = createContext({});

const FilterProvider = ({ children, filters = {}, onFilterChange }) => {
  const initState = {
    filters: filters, // 실제 적용된 필터값
    draftFilters: filters, // 수정 중인 필터값
    showFilterPanel: false,
  };

  const [filterState, dispatch] = useReducer(filterReducer, initState);

  useEffect(() => {
    dispatch({
      type: 'SET_FILTERS',
      payload: filters,
    });
  }, [filters]);

  const filterDispatch = useCallback(
    action => {
      dispatch(action);

      if (action.type === 'APPLY_FILTERS') {
        // remove _display field
        const cleanFilters = {};
        Object.entries(filterState.draftFilters).forEach(([key, value]) => {
          if (!key.endsWith('_display')) {
            cleanFilters[key] = value;
          }
        });
        onFilterChange?.(cleanFilters);
      } else if (action.type === 'RESET_FILTERS') {
        onFilterChange?.(action.payload);
      }
    },
    [filterState.draftFilters, onFilterChange],
  );

  return (
    <FilterContext.Provider value={{ filterState, filterDispatch }}>
      {children}
    </FilterContext.Provider>
  );
};

FilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
};

export const useFilterContext = () => useContext(FilterContext);

export default FilterProvider;
